import { render } from "./FranchiseRequirements.vue?vue&type=template&id=8d6b43a4&scoped=true&ts=true"
import script from "./FranchiseRequirements.vue?vue&type=script&lang=ts"
export * from "./FranchiseRequirements.vue?vue&type=script&lang=ts"

import "./FranchiseRequirements.vue?vue&type=style&index=0&id=8d6b43a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6b43a4"]])

export default __exports__